import { render, staticRenderFns } from "./DeviceGroupStats.vue?vue&type=template&id=4d10b940&scoped=true&"
import script from "./DeviceGroupStats.vue?vue&type=script&lang=js&"
export * from "./DeviceGroupStats.vue?vue&type=script&lang=js&"
import style0 from "./DeviceGroupStats.vue?vue&type=style&index=0&id=4d10b940&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d10b940",
  null
  
)

export default component.exports